
import update from 'immutability-helper';
import { DataSourceActions } from './DataSourceActions';

const initialState = {
    listaDataSource: null,
    statusDett: false
}

const DataSourceReducer = (state, action) => {

    if (typeof state === 'undefined') {
        return initialState
    }

    switch (action.type) {
        case DataSourceActions.DATA_SOURCE_LIST:
            return update(state, { listaDataSource: { $set: action.result } });

        case DataSourceActions.STATUS_DETTAGLIO:
            return update(state, { statusDett: { $set: action.result } });
        default:
            return state;
    }
}

export default DataSourceReducer;